import ajax from "../utils/request";

const CheckTaskApi = {
  /********************************金刚区配置列表*********************************** */
  // 获取金刚区列表
  list(params) {
    return ajax({
      url: "/checktasks/list",
      type: "post",
      params: params,
    });
  },
  save(param) {
    return ajax({
      url: "/checktasks/add",
      type: "post",
      params: param,
    });
  },
  update(param) {
    return ajax({
      url: "/checktasks/update",
      type: "post",
      params: param,
    });
  },
  remove(param) {
    return ajax({
      url: "/checktasks/del",
      type: "post",
      params: param,
    });
  },
  copy(param) {
    return ajax({
      url: "/checktasks/copy",
      type: "post",
      params: param,
    });
  },
  field(param) {
    return ajax({
      url: "/checktasks/field",
      type: "post",
      params: param,
    });
  }
};

export default CheckTaskApi;
